import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { isEmpty } from "lodash";
import InfiniteScroll from "react-infinite-scroller";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";

import Loader from "../Common/Loader";
import Picture from "../Common/Picture";
import DatePicker from "../Common/DatePicker";
import CustomButton from "../Common/CustomButton";
import NotFound from "../NotFound";

import { setBreadcrumb } from "../../actions/common";
import { fetchPost } from "../../api/fetch";

import { getLov } from "../../utils/lov";
import { formatDate, nowWithOutSeconds } from "../../utils/date";
import { getLovValue } from "../../utils/profile";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import {
  TableBody,
  TableHead,
  TableCell,
  Table,
  TableRow,
} from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  root: {
    borderRight: `1px solid ${colors.veryLighPink}`,
  },
}))(TableCell);

const styles = {
  section: {
    marginBottom: "30px",
  },
  sectionTitle: {
    fontWeight: "500",
    fontSize: "1.2em",
    margin: "20px 0px",
    padding: "10px",
    borderBottom: "1px solid " + colors.veryLighPink,
  },
  checkbox: {
    padding: 0,
  },
  clickableHeader: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const Stats2 = (props) => {
  const { classes, dispatch, powerUserModeEnabled } = props;
  const [stats, setStats] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [lov, setLov] = React.useState({});
  const [formValues, setFormValues] = React.useState({
    startDate: nowWithOutSeconds() - 86400000,
    endDate: nowWithOutSeconds(),
  });
  const [hideMatchRequestEvents, setHideMatchRequestEvents] = React.useState(
    true
  );

  const [displayNbOcrLpr, setDisplayNbOcrLpr] = React.useState(10);
  const [displayNbEntranceExit, setDisplayNbEntranceExit] = React.useState(10);

  const [sortByEntranceExit, setSortByEntranceExit] = React.useState();
  const [sortDescEntranceExit, setSortDescEntranceExit] = React.useState(false);

  const [sortByOcrLpr, setSortByOcrLpr] = React.useState();
  const [sortDescOcrLpr, setSortDescOcrLpr] = React.useState(false);

  React.useEffect(() => {
    dispatch(setBreadcrumb([{ name: I18n.get("topbar_stats2") }]));
    const fetchLov = async () => {
      setLov({
        status: await getLov("status"),
        eventGroupType: await getLov("eventGroupTypes"),
        eventType: await getLov("eventTypes"),
      });
    };
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setFormValues(
      update(formValues, {
        [field]: { $set: new Date(value).getTime() },
      })
    );
  };

  const handleSearch = async () => {
    try {
      setStats({});
      setLoading(true);
      let body = {
        start: formValues.startDate,
        end: formValues.endDate,
      };

      let ocrLprSummary = await fetchPost(
        "/system/statistics/ocr_lpr_summary",
        body
      );
      let ocrLprDetails = await fetchPost(
        "/system/statistics/ocr_lpr_details",
        body
      );
      let entranceExitSummary = await fetchPost(
        "/system/statistics/entrance_exit_summary",
        body
      );
      let entranceExitDetails = await fetchPost(
        "/system/statistics/entrance_exit_details",
        body
      );
      console.log({
        ...ocrLprSummary,
        ...ocrLprDetails,
        ...entranceExitSummary,
        ...entranceExitDetails,
      });
      setStats({
        ...ocrLprSummary,
        ...ocrLprDetails,
        ...entranceExitSummary,
        ...entranceExitDetails,
      });
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
      setError(
        "The request to the database failed. If the specified period is too large, the API can't return all the requested data and fails. Try specifying a shorter period."
      );
    }
  };

  const displayPercentage = (a, b) => {
    return `${parseFloat((100 * a) / b).toFixed(1)}%`;
  };

  const sort = (table, field) => {
    if (table === "ocrLpr") {
      if (sortByOcrLpr === field) {
        setSortDescOcrLpr(!sortDescOcrLpr);
      } else {
        setSortByOcrLpr(field);
      }
    } else if (table === "entranceExit") {
      if (sortByEntranceExit === field) {
        setSortDescEntranceExit(!sortDescEntranceExit);
      } else {
        setSortByEntranceExit(field);
      }
    }
  };

  const renderSortableHeader = (table, field) => {
    let sortBy = table === "ocrLpr" ? sortByOcrLpr : sortByEntranceExit;
    let sortDesc = table === "ocrLpr" ? sortDescOcrLpr : sortDescEntranceExit;
    return (
      <StyledTableCell onClick={() => sort(table, field)}>
        <span className={classes.clickableHeader}>
          {I18n.get(`stat_${field}`)}
          {sortBy === field && (
            <img
              style={{ marginLeft: "5px" }}
              src={sortDesc ? images.bottomArrow : images.topArrow}
              alt="arrow"
            />
          )}
        </span>
      </StyledTableCell>
    );
  };

  const renderOcrLprSummary = () => {
    if (!stats["LPR/OCR Summary"]) return null;
    const data = stats["LPR/OCR Summary"];
    const ocrReviewedCount =
      parseInt(data["EOCR Request Correction"].count) +
      parseInt(data["EOCR Request Accurate"].count);
    const lprReviewedCount =
      parseInt(data["ELPR Request Correction"].count) +
      parseInt(data["ELPR Request Accurate"].count);
    const reviewedCount = ocrReviewedCount + lprReviewedCount;
    const totalCount =
      data["EOCR Request Total"].count + data["ELPR Request Total"].count;

    return (
      <Grid item className={classes.section}>
        <Box className={classes.sectionTitle}>
          {I18n.get("stat_lprOcrSummary")}
        </Box>
        <Table stickyHeader style={{ maxWidth: "800px" }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>{I18n.get("stat_eventType")}</StyledTableCell>
              <StyledTableCell>{I18n.get("stat_count")}</StyledTableCell>
              <StyledTableCell>
                {I18n.get("stat_percentageTotal")}
              </StyledTableCell>
              <StyledTableCell>
                {I18n.get("stat_percentageReviewed")}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className="bold-500">
              <StyledTableCell className="bold-500">
                {"EOCR Request Total"}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {data["EOCR Request Total"].count}
              </StyledTableCell>
              <StyledTableCell className="bold-500">{`${parseFloat(
                data["EOCR Request Total"].percent
              ).toFixed(1)}%`}</StyledTableCell>
              <StyledTableCell />
            </TableRow>
            <TableRow>
              <StyledTableCell className="bold-500">
                {"ELPR Request Total"}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {data["ELPR Request Total"].count}
              </StyledTableCell>
              <StyledTableCell className="bold-500">{`${parseFloat(
                data["ELPR Request Total"].percent
              ).toFixed(1)}%`}</StyledTableCell>
              <StyledTableCell />
            </TableRow>
            <TableRow>
              <StyledTableCell className="bold-500">
                {"Total Reviewed"}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {reviewedCount}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {displayPercentage(reviewedCount, totalCount)}
              </StyledTableCell>
              <StyledTableCell />
            </TableRow>
            <TableRow style={{ height: "31px" }}>
              <StyledTableCell colSpan={4} />
            </TableRow>
            <TableRow>
              <StyledTableCell className="bold-500">
                {"EOCR Correction + Accurate"}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {ocrReviewedCount}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {displayPercentage(ocrReviewedCount, totalCount)}
              </StyledTableCell>
              <StyledTableCell className="bold-500">{`${parseFloat(100).toFixed(
                1
              )}%`}</StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell style={{ textAlign: "right" }}>
                {"EOCR Request Correction"}
              </StyledTableCell>
              <StyledTableCell>
                {data["EOCR Request Correction"].count}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["EOCR Request Correction"].count,
                  totalCount
                )}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["EOCR Request Correction"].count,
                  ocrReviewedCount
                )}
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell style={{ textAlign: "right" }}>
                {"EOCR Request Accurate"}
              </StyledTableCell>
              <StyledTableCell>
                {data["EOCR Request Accurate"].count}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["EOCR Request Accurate"].count,
                  totalCount
                )}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["EOCR Request Accurate"].count,
                  ocrReviewedCount
                )}
              </StyledTableCell>
            </TableRow>
            <TableRow style={{ height: "31px" }}>
              <StyledTableCell colSpan={4} />
            </TableRow>
            <TableRow>
              <StyledTableCell className="bold-500">
                {"ELPR Correction + Accurate"}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {lprReviewedCount}
              </StyledTableCell>
              <StyledTableCell className="bold-500">
                {displayPercentage(lprReviewedCount, totalCount)}
              </StyledTableCell>
              <StyledTableCell className="bold-500">{`${parseFloat(100).toFixed(
                1
              )}%`}</StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell style={{ textAlign: "right" }}>
                {"ELPR Request Correction"}
              </StyledTableCell>
              <StyledTableCell>
                {data["ELPR Request Correction"].count}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["ELPR Request Correction"].count,
                  totalCount
                )}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["ELPR Request Correction"].count,
                  lprReviewedCount
                )}
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell style={{ textAlign: "right" }}>
                {"ELPR Request Accurate"}
              </StyledTableCell>
              <StyledTableCell>
                {data["ELPR Request Accurate"].count}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["ELPR Request Accurate"].count,
                  totalCount
                )}
              </StyledTableCell>
              <StyledTableCell>
                {displayPercentage(
                  data["ELPR Request Accurate"].count,
                  lprReviewedCount
                )}
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    );
  };

  const renderOcrLprDetail = () => {
    if (!stats["LPR/OCR Detailed View"]) return null;
    let data = stats["LPR/OCR Detailed View"];
    data = data.filter(
      (item) => !hideMatchRequestEvents || item.correction || item.accurate
    );
    if (sortByOcrLpr) {
      data = data.sort((a, b) => {
        const factor = sortDescOcrLpr ? -1 : 1;
        if (a[sortByOcrLpr] > b[sortByOcrLpr]) {
          return factor;
        } else {
          return factor * -1;
        }
      });
    }

    return (
      <Grid item className={classes.section}>
        <Grid container className={classes.sectionTitle} alignItems="center">
          <Grid item xs={6}>
            {`${I18n.get("stat_lprOcrDetailedView")} (${data.length} results)`}
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right", fontWeight: "400" }}>
            <Checkbox
              classes={{ root: classes.checkbox }}
              color="primary"
              size="small"
              checked={hideMatchRequestEvents}
              onChange={() =>
                setHideMatchRequestEvents(!hideMatchRequestEvents)
              }
            />
            <Box
              component="span"
              className="text-87"
              style={{ marginLeft: "10px", fontSize: "0.850em" }}
            >
              Hide Match Request Events
            </Box>
          </Grid>
        </Grid>
        <Box style={{ maxHeight: "600px", overflow: "auto" }}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => setDisplayNbOcrLpr(displayNbOcrLpr + 10)}
            hasMore={data.length > displayNbOcrLpr}
            loader={
              <div className="loader" key={0}>
                Loading ...
              </div>
            }
            useWindow={false}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {renderSortableHeader("ocrLpr", "type")}
                  {renderSortableHeader(
                    "ocrLpr",
                    "parent_event_group_created_on"
                  )}
                  {renderSortableHeader("ocrLpr", "parent_event_group_id")}
                  {renderSortableHeader("ocrLpr", "event_group_id")}
                  {renderSortableHeader("ocrLpr", "event_id")}
                  <StyledTableCell>
                    {I18n.get("stat_imageCrop")}
                  </StyledTableCell>
                  {renderSortableHeader("ocrLpr", "detected_value")}
                  {renderSortableHeader("ocrLpr", "corrected_value")}
                  {renderSortableHeader("ocrLpr", "correction_event_type_id")}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.slice(0, displayNbOcrLpr).map((item, index) => (
                  <TableRow key={index}>
                    <StyledTableCell>
                      {getLovValue("eventType", item.type, lov, "en")}
                    </StyledTableCell>
                    <StyledTableCell>
                      {formatDate(item.parent_event_group_created_on)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {item.parent_event_group_id}
                    </StyledTableCell>
                    <StyledTableCell>{item.event_group_id}</StyledTableCell>
                    <StyledTableCell>{item.event_id}</StyledTableCell>
                    <StyledTableCell>
                      <Picture
                        url={item.image}
                        alt="cropped"
                        maxHeight={60}
                        justify="flex-start"
                        style={{
                          maxWidth: "60px",
                          maxHeight: "60px",
                          borderRadius: "3px",
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      {item.detected_value || "-"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {item.corrected_value || "-"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {getLovValue(
                        "eventType",
                        item.correction_event_type_id,
                        lov,
                        "en"
                      )}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </InfiniteScroll>
        </Box>
      </Grid>
    );
  };

  const renderEntranceExitSummary = () => {
    if (!stats["Entrance/Exit Summary - Count by Status"]) return null;
    let data = stats["Entrance/Exit Summary - Count by Status"];
    let totals = {
      status1: 0,
      status2: 0,
      status3: 0,
      status4: 0,
      status5: 0,
    };
    Object.keys(data).forEach((k) => {
      totals.status1 += data[k]["Status 1"].count;
      totals.status2 += data[k]["Status 2"].count;
      totals.status3 += data[k]["Status 3"].count;
      totals.status4 += data[k]["Status 4"].count;
      totals.status5 += data[k]["Status 5"].count;
    });
    totals.sum =
      totals.status1 +
      totals.status2 +
      totals.status3 +
      totals.status4 +
      totals.status5;

    return (
      <Grid item className={classes.section}>
        <Box className={classes.sectionTitle}>
          {I18n.get("stat_entranceExitSummary")}
        </Box>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell>{I18n.get("stat_gateType")}</StyledTableCell>
              <StyledTableCell>{`${I18n.get(
                "stat_status"
              )} 1 In Progress`}</StyledTableCell>
              <StyledTableCell>{`${I18n.get(
                "stat_status"
              )} 2 Completed`}</StyledTableCell>
              <StyledTableCell>{`${I18n.get(
                "stat_status"
              )} 3 Verified All OK`}</StyledTableCell>
              <StyledTableCell>{`${I18n.get(
                "stat_status"
              )} 4 Verified & Corrected`}</StyledTableCell>
              <StyledTableCell>{`${I18n.get(
                "stat_status"
              )} 5 Require Correction/s`}</StyledTableCell>
              <StyledTableCell>{I18n.get("stat_sum")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(data).map((k) => (
              <TableRow key={k}>
                <StyledTableCell>{k}</StyledTableCell>
                <StyledTableCell>{`${data[k]["Status 1"].count} (${parseFloat(
                  data[k]["Status 1"].percent
                ).toFixed(2)}%)`}</StyledTableCell>
                <StyledTableCell>{`${data[k]["Status 2"].count} (${parseFloat(
                  data[k]["Status 2"].percent
                ).toFixed(2)}%)`}</StyledTableCell>
                <StyledTableCell>{`${data[k]["Status 3"].count} (${parseFloat(
                  data[k]["Status 3"].percent
                ).toFixed(2)}%)`}</StyledTableCell>
                <StyledTableCell>{`${data[k]["Status 4"].count} (${parseFloat(
                  data[k]["Status 4"].percent
                ).toFixed(2)}%)`}</StyledTableCell>
                <StyledTableCell>{`${data[k]["Status 5"].count} (${parseFloat(
                  data[k]["Status 5"].percent
                ).toFixed(2)}%)`}</StyledTableCell>
                <StyledTableCell>{`${data[k]["Sum"].count} (${data[k]["Sum"].percent}%)`}</StyledTableCell>
              </TableRow>
            ))}
            <TableRow>
              <StyledTableCell />
              <StyledTableCell className="bold-500">{`${
                totals.status1
              } (${displayPercentage(
                totals.status1,
                totals.sum
              )})`}</StyledTableCell>
              <StyledTableCell className="bold-500">{`${
                totals.status2
              } (${displayPercentage(
                totals.status2,
                totals.sum
              )})`}</StyledTableCell>
              <StyledTableCell className="bold-500">{`${
                totals.status3
              } (${displayPercentage(
                totals.status3,
                totals.sum
              )})`}</StyledTableCell>
              <StyledTableCell className="bold-500">{`${
                totals.status4
              } (${displayPercentage(
                totals.status4,
                totals.sum
              )})`}</StyledTableCell>
              <StyledTableCell className="bold-500">{`${
                totals.status5
              } (${displayPercentage(
                totals.status5,
                totals.sum
              )})`}</StyledTableCell>
              <StyledTableCell className="bold-500">{`${
                totals.sum
              } (${displayPercentage(
                totals.sum,
                totals.sum
              )})`}</StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    );
  };

  const renderEntranceExitDetail = () => {
    if (!stats["Entrance/Exit Detail"]) return null;
    let data = stats["Entrance/Exit Detail"];
    if (sortByEntranceExit) {
      data = data.sort((a, b) => {
        const factor = sortDescEntranceExit ? -1 : 1;
        if (a[sortByEntranceExit] < b[sortByEntranceExit]) {
          return factor;
        } else {
          return factor * -1;
        }
      });
    }
    return (
      <Grid item className={classes.section}>
        <Box className={classes.sectionTitle}>
          {I18n.get("stat_entranceExitDetail")}
        </Box>
        <Box style={{ maxHeight: "600px", overflow: "auto" }}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() =>
              setDisplayNbEntranceExit(displayNbEntranceExit + 10)
            }
            hasMore={data.length > displayNbEntranceExit}
            loader={
              <div className="loader" key={0}>
                Loading ...
              </div>
            }
            useWindow={false}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {renderSortableHeader("entranceExit", "event_group_id")}
                  {renderSortableHeader("entranceExit", "event_group_type_id")}
                  {renderSortableHeader(
                    "entranceExit",
                    "event_group_status_id"
                  )}
                  {renderSortableHeader("entranceExit", "comment")}
                  {renderSortableHeader("entranceExit", "processed_on")}
                  <StyledTableCell>
                    {I18n.get("stat_childEventGroups")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.slice(0, displayNbEntranceExit).map((item, index) => (
                  <TableRow key={index}>
                    <StyledTableCell>{item.event_group_id}</StyledTableCell>
                    <StyledTableCell>
                      {getLovValue(
                        "eventGroupType",
                        item.event_group_type_id,
                        lov,
                        "en"
                      )}
                    </StyledTableCell>
                    <StyledTableCell>
                      {getLovValue(
                        "status",
                        item.event_group_status_id,
                        lov,
                        "en"
                      )}
                    </StyledTableCell>
                    <StyledTableCell>{item.comment || "-"}</StyledTableCell>
                    <StyledTableCell>
                      {formatDate(item.event_group_processed_on)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {item.child_event_group_ids.map(
                        (item, index) => `${item}, `
                      )}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </InfiniteScroll>
        </Box>
      </Grid>
    );
  };

  if (!powerUserModeEnabled) {
    return <NotFound />;
  }

  return (
    <Box className="mainContainer">
      <Grid
        container
        direction="column"
        className="mainContent"
        wrap="nowrap"
        style={{
          padding: "12px",
          maxWidth: "1920px",
          height: "calc(100vh - 148px)",
          overflow: "auto",
        }}
      >
        <Grid item style={{ marginTop: "20px" }}>
          <Grid container justify="center">
            <Grid item style={{ maxWidth: "300px", marginRight: "24px" }}>
              <DatePicker
                label={I18n.get("site_startDate")}
                name="startDate"
                value={formValues.startDate}
                onChange={handleChange}
              />
            </Grid>
            <Grid item style={{ maxWidth: "300px" }}>
              <DatePicker
                label={I18n.get("site_endDate")}
                name="endDate"
                value={formValues.endDate}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              style={{
                marginLeft: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomButton
                variant="contained"
                color="primary"
                style={{ margin: 0 }}
                onClick={handleSearch}
              >
                {I18n.get("site_search")}
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
        {loading && (
          <Grid item xs>
            <Loader width="100%" height="100%" noDecoration />
          </Grid>
        )}
        {error && (
          <Grid item xs>
            {error}
          </Grid>
        )}
        {stats && !isEmpty(stats) && renderOcrLprSummary()}
        {stats && !isEmpty(stats) && renderOcrLprDetail()}
        {stats && !isEmpty(stats) && renderEntranceExitSummary()}
        {stats && !isEmpty(stats) && renderEntranceExitDetail()}
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    powerUserModeEnabled: state.common.powerUserModeEnabled,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(Stats2));
